import { EventEmitter } from "@angular/core";
import { map } from "rxjs";
import { SubscriberComponent } from "../../components/subscriber/subscriber.component";
// This serves as the strategy interface , since javascript has no comprehension of interfaces for providers
export class AflaModuleStrategyService extends SubscriberComponent {
    onCleanFormEvent = new EventEmitter();
    constructor() {
        super();
    }
    static buildModuleIDFilter(moduleID) {
        return `moduleID eq ${moduleID}`;
    }
    static buildJobIDFilter(jobId) {
        return `jobId eq ${jobId}`;
    }
    static successMessage(referenceNumber, section) {
        return `Application ${referenceNumber} ${section} saved successfully`;
    }
    setIsFormValidSubject(valid) {
        this.isFormValidSubject.next(valid);
    }
    getConfigurationTextLookup(moduleId) {
        return this.queryConfigurableTextLookup(this.configurableTextFilter(moduleId)).pipe(map(odataCollection => {
            const contents = new Array();
            odataCollection.value.forEach(vl => {
                try {
                    contents.push(JSON.parse(vl.content));
                }
                catch {
                }
            });
            return contents;
        }));
    }
    init() {
        this.initializeViewApplicationComponents();
        this.initializeCreateApplicationComponents();
        this.initializeApplicationSummaryColumnsMap();
        this.initialiseCreateApplicationSteps();
        this.initialiseViewApplicationSteps();
    }
    configurableTextFilter(moduleId) {
        return `moduleId eq ${moduleId} and name eq 'ConfigurableText' and deleted eq false`;
    }
}
